// const BASE_URL="http://192.168.1.121:8848"

const BASE_URL="https://api.lqcpws.cn"

export default{BASE_URL}